<template>
  <div class="container">
    <div class="container__inner container__inner--min exhibition">
      <h2 class="contentTitle contentTitle--center">東京展</h2>
    </div>
    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">アクセス</p>
      <div class="exhibition__cont">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.0346971050517!2d139.77789691497446!3d35.67614763785876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018895c5a647fd7%3A0xaa819cb9fd2e7aa9!2z77yI5qCq77yJ5YaF55Sw5rSL6KGMIOadseS6rOODpuODk-OCreOCv-OCueWNlOWJteW6g-WgtCBDQU5WQVM!5e0!3m2!1sja!2sjp!4v1549686713207"
          width="640"
          height="320"
          frameborder="0"
          allowfullscreen
          class="exhibition__cont__map"
        ></iframe>
      </div>
      <ul class="exhibition__cont detailTable">
        <li class="detailTable__item">
          <p class="detailTable__item__title">住所</p>
          <p class="detailTable__item__cont">〒104-0033 東京都中央区新川2丁目4-7</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">公式HP</p>
          <p class="detailTable__item__cont">
            <a
              href="https://www.uchida.co.jp/company/showroom/canvas/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >uchida.co.jp/company/showroom/canvas/</a>
          </p>
        </li>
      </ul>
      <div class="exhibition__cont exhibition__cont--center">
        <a
          class="subButton"
          href="https://www.uchida.co.jp/company/showroom/canvas/tokyo/"
          target="_blank"
          rel="noopener noreferrer"
        >会場への行き方を見る</a>
      </div>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">開催概要</p>
      <ul class="exhibition__cont detailTable">
        <li class="detailTable__item">
          <p class="detailTable__item__title">日程</p>
          <p class="detailTable__item__cont">2019年2月17(日) 〜 18日(月)</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">場所</p>
          <p class="detailTable__item__cont">ユビキタス協創広場 CANVAS</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">時間</p>
          <p class="detailTable__item__cont">10:00 〜 17:00</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">主催</p>
          <p class="detailTable__item__cont">公立はこだて未来大学 情報デザインコース</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">共催</p>
          <p class="detailTable__item__cont">株式会社内田洋行 / パワープレイス株式会社</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">協力</p>
          <p class="detailTable__item__cont">学術連携室 / 社会連携センター</p>
        </li>
      </ul>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">ゲストトーク</p>
      <div class="exhibition__cont">
        <img src="../../../assets/Tokyo/guest.jpg" alt>
      </div>
      <ul class="exhibition__cont detailTable">
        <li class="detailTable__item">
          <p class="detailTable__item__title">日程</p>
          <p class="detailTable__item__cont">2019年2月17日(日)</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">時間</p>
          <p class="detailTable__item__cont">10:30 〜 11:30</p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">登壇者</p>
          <p class="detailTable__item__cont">山田 翔 氏
            <br>株式会社アドウェイズ取締役 /
            <br>Bulbit株式会代表取締役
          </p>
        </li>
        <li class="detailTable__item">
          <p class="detailTable__item__title">内容</p>
          <p class="detailTable__item__cont">今回のコンセプトである「新ふつうデザイン」に関連し、
            <br>山田さんのお仕事を中心にお話をしていただきます。
          </p>
        </li>
      </ul>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">タイムテーブル: 1日目</p>
      <table class="exhibition__cont timeTable2">
        <tr>
          <th>10:00</th>
          <td>開場</td>
        </tr>
        <tr>
          <th class="rangeTime">
            <span>10:30</span>
            <span>11:30</span>
          </th>
          <td>ゲストトーク</td>
        </tr>
        <tr>
          <th class="rangeTime">
            <span>13:00</span>
            <span>15:00</span>
          </th>
          <td>プレゼンテーション</td>
        </tr>
        <tr>
          <th class="rangeTime">
            <span>15:00</span>
            <span>16:00</span>
          </th>
          <td>ポスターセッション</td>
        </tr>
        <tr>
          <th>17:00</th>
          <td>閉場</td>
        </tr>
      </table>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">タイムテーブル: 2日目</p>
      <table class="exhibition__cont timeTable2">
        <tr>
          <th>10:00</th>
          <td>開場</td>
        </tr>
        <tr>
          <th class="rangeTime">
            <span>13:00</span>
            <span>15:00</span>
          </th>
          <td>ポスターセッション</td>
        </tr>
        <tr>
          <th>17:00</th>
          <td>閉場</td>
        </tr>
      </table>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">展示内容</p>
      <div class="exhibition__cont">
        <img src="../../../assets/Tokyo/pamphlet.svg" alt>
      </div>
    </div>

    <div class="container__inner container__inner--min exhibition">
      <p class="subContentTitle">東京展は終了致しました！</p>
      <div class="exhibition__cont">
        <img src="../../../assets/Tokyo/photo01.jpg" alt>
        <img src="../../../assets/Tokyo/photo02.jpg" alt>
        <img src="../../../assets/Tokyo/photo03.jpg" alt>
        <img src="../../../assets/Tokyo/photo04.jpg" alt>
        <img src="../../../assets/Tokyo/photo05.jpg" alt>
        <img src="../../../assets/Tokyo/photo06.jpg" alt>
        <img src="../../../assets/Tokyo/photo07.jpg" alt>
        <img src="../../../assets/Tokyo/photo08.jpg" alt>
        <img src="../../../assets/Tokyo/photo09.jpg" alt>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'o-exibitions'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$white: #fff;
$yellow: #eddb44;
$thin-yellow: #f2e680;
$blue: #009898;

.container {
  margin-top: calc(72px + 80px);
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    margin-top: calc(32px + 56px);
  }
  @media screen and (max-width: 411px) {
    margin-top: calc(32px + 40px);
  }
}

.timeTable2 {
  width: 100%;
  padding: 16px;
  background: $yellow;
  tr {
    display: flex;
    &:not(:first-child) {
      margin-top: 16px;
    }
    th,
    td {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 16px 24px;
      background: $thin-yellow;
      letter-spacing: 1.5px;
      color: $blue;
      font-size: 18px;
      font-weight: 700;
      line-height: 1.5;
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
    th {
      width: 106px;
      &.rangeTime {
        display: flex;
        flex-direction: column;
        span:not(:first-child) {
          &::before {
            content: "";
            display: block;
            width: 3px;
            height: 12px;
            margin: 4px auto;
            background: $blue;
            border-radius: 4px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 411px) {
    padding: 8px;
    tr {
      &:not(:first-child) {
        margin-top: 8px;
      }
      th,
      td {
        font-size: 16px;
        padding: 8px;
        &:not(:first-child) {
          margin-left: 4px;
        }
      }
      th {
        &.rangeTime {
          span:not(:first-child) {
            &::before {
              width: 2px;
            }
          }
        }
      }
    }
    &__item {
      display: flex;
      &__title {
        &__box {
          padding: 8px 16px;
          &:first-child {
            margin-bottom: 8px;
          }
        }
      }
      &:not(:nth-child(2)) > .timeTable__item__title {
        padding: 8px 16px;
      }
      &__cont {
        padding: 8px;
        margin-left: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Tokyo/index.vue